import React from 'react'

import { useThemeEditorContext } from '../../../../hooks/useThemeEditorContext'
import { useThemeLivePreviewContext } from '../../providers/ThemeLivePreviewProvider'
import { AddSectionToolbar } from '../AddSectionToolbar/AddSectionToolbar'
import { InspectorToolbar } from '../InspectorToolbar/InspectorToolbar'
import * as S from './styled'

export const InspectorFrame = () => {
  const { rect, activeSectionKey, isInspectorVisible } = useThemeLivePreviewContext()
  const { isPreviewLoading } = useThemeEditorContext()

  // Don't render the frame if there's no active section
  if (!activeSectionKey) return null

  return (
    <S.Layout>
      <S.Frame
        style={{
          top: rect.top,
          left: rect.left,
          width: rect.width,
          height: rect.height,
          opacity: isPreviewLoading || !isInspectorVisible ? 0 : 1,
          visibility: isPreviewLoading || !isInspectorVisible ? 'hidden' : 'visible',
        }}
      >
        <AddSectionToolbar position="top" />
        <InspectorToolbar />
        <AddSectionToolbar position="bottom" />
      </S.Frame>
    </S.Layout>
  )
}
